export default "__VITE_ASSET__20f4e479__"